import { useEffect, useState } from "react";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import { api } from "@/lib/api";
import { langLabel } from "@/lib/i18n";

export default function QuickPacketFields({ open, lang, ids, setIds, largePrint, setLargePrint, facility, provider }) {
  const [all, setAll] = useState([]);
  const [dflt, setDflt] = useState(null);
  useEffect(() => { if (open) api.get("/templates").then((r) => setAll(r.data.filter((t) => t.status === "active"))).catch(() => {}); }, [open]);
  useEffect(() => {
    if (!open) return;
    api.get("/default-packets/resolve", { params: { facility: facility || "", provider: provider || "" } }).then((r) => { setDflt(r.data); setIds(r.data.template_ids); }).catch(() => {});
  }, [open, facility, provider]); // eslint-disable-line react-hooks/exhaustive-deps
  const base = all.filter((t) => t.language === "en-US");
  const has = (t) => lang === "en-US" || all.some((x) => x.family_id === t.family_id && x.language === lang);
  return (
    <div className="border rounded-md p-3 bg-slate-50" data-testid="quick-packet-fields">
      <Label>Forms to sign (default packet)</Label>
      <p className="text-xs text-slate-500" data-testid="quick-default-source">{dflt?.scope === "provider" ? "Pre-selected from the provider's own default packet." : dflt?.scope === "facility" ? "Pre-selected from this facility's default packet." : dflt?.scope === "organization" ? "Pre-selected from the organization default packet." : "No default packet set up - pick forms or leave empty."} The packet is added to the pending list when you save.</p>
      <div className="grid gap-1.5 mt-2">
        {base.map((t) => (
          <label key={t.id} className="flex items-start gap-2 text-sm cursor-pointer">
            <Checkbox className="mt-0.5" checked={ids.includes(t.id)} onCheckedChange={(v) => setIds(v ? [...ids, t.id] : ids.filter((x) => x !== t.id))} data-testid={`quick-template-${t.id}`} />
            <span>{t.name}{lang !== "en-US" && <span className={`block text-xs ${has(t) ? "text-green-700" : "text-amber-700"}`}>{has(t) ? `${langLabel(lang)} version available` : "English only - interpreter needed"}</span>}</span>
          </label>
        ))}
        {!base.length && <p className="text-xs text-slate-500">No approved forms yet.</p>}
      </div>
      <label className="flex items-center gap-2 text-sm mt-3"><Checkbox checked={largePrint} onCheckedChange={(v) => setLargePrint(v === true)} data-testid="quick-large-print" />Open signing screens in large print</label>
    </div>
  );
}
